import { Stack } from "@mui/material";
import type { ReactNode } from "react";

/**
 * Section wrappers shared by the anonymous payment first-step screens
 * (collector step one and the payment detail step) so their layouts
 * cannot drift apart.
 */

/* Centered in the space between the page logo and the bottom section */
export const MainSection = ({ children }: { children: ReactNode }) => (
  <Stack flexGrow={1} justifyContent="center" gap={7}>
    {children}
  </Stack>
);

/* Bottom section — pinned above the sign-in prompt */
export const BottomSection = ({ children }: { children: ReactNode }) => (
  <Stack gap={4}>{children}</Stack>
);
